import { ApplicationElement } from '../application_element/element.js';
import Snack from '@effectivastudio/snackbar';

/**
 * Display as snackbar when in HTML.
 *
 * Only one can be displayed at the time.
 *
 * That is the reason why on demo you can see only last one.
 *
 * @prop type - Styles - default / danger
 */
export default class Snackbar extends ApplicationElement {
  static properties = {
    type: { type: String },
  };

  constructor() {
    super();
    this.type = 'default';
  }

  connectedCallback() {
    this.hidden = true;

    requestAnimationFrame(() => {
      Snack({
        text: this.innerHTML,
        customClass: this.customClass,
      });
    });
  }

  get customClass() {
    return {
      danger: 'snackbar-danger',
      success: 'snackbar-success',
      default: 'snackbar-default',
    }[this.type];
  }
}

customElements.get('ef-snackbar') ||
  customElements.define('ef-snackbar', Snackbar);
